import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { RmColumnsRepository } from './rm-column.repository';
import { RmColumnsService } from './rm-column-service';
import { RmColumnsAdapter } from './dto/rm-columns.adapter';
import { RmColumnsController } from './rm-columns-controller';

@Module({
  imports: [
    TypeOrmModule.forFeature([RmColumnsRepository])
  ],

  providers: [RmColumnsService,RmColumnsAdapter, ApplicationExceptionHandler],
  controllers: [RmColumnsController]
})
export class RmColumnsModule {}
